var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { AwesomeComponent, ComponentType } from '@philips-internal/oswald-ui-core';
import React, { Component } from 'react';
import './html-viewer.css';
import { TextArea } from '@philips-internal/oswald-ui-components/lib/components';
import HtmlViewerAPI from './html-viewer-api';
import { string } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
import { bool } from '@philips-internal/oswald-ui-core/lib/component/prop-types';
let HtmlViewer = class HtmlViewer extends Component {
    constructor() {
        super(...arguments);
        this.getDescription = () => {
            const { value } = this.props;
            return value;
        };
    }
    static { this.propTypes = {
        isHtmlData: bool,
        value: string,
    }; }
    render() {
        const { isHtmlData } = this.props;
        return (React.createElement("div", { className: 'c-html-viewer' },
            isHtmlData &&
                React.createElement("div", { className: 'c-html-viewer-content', dangerouslySetInnerHTML: { __html: this.getDescription() } }),
            !isHtmlData &&
                React.createElement(TextArea, { value: this.getDescription(), rows: 7, readOnly: true })));
    }
};
HtmlViewer = __decorate([
    AwesomeComponent({ api: HtmlViewerAPI, type: ComponentType.DATA_DISPLAY })
], HtmlViewer);
export default HtmlViewer;
//# sourceMappingURL=html-viewer.js.map